import { createSlice } from '@reduxjs/toolkit';

const searchSlice = createSlice({
  name: 'search',
  initialState: {
    articles: [],
    totalArticles: 0,
    searchInput: '',
    pageNumber: 0,
    lastFetchedPage: 0,
    maxPage: 0,
    queries: [],
    advanceSearchQuery: {},
    loading: false,
    loadingAuthors: false,
    loadingPublications: false,
    authors: [],
    publications: [],
    menu: [],
    bookmarks: [],
    loadingMenu: false,
    downloadProgress: 0,
    loadingDownload: false
  },
  reducers: {
    setLoader(state, action) {
      state.loading = action.payload
    },
    setDownloadLoader(state, action) {
      state.loadingDownload = action.payload
    },
    setDownloadProgress(state, action) {
      state.downloadProgress = action.payload
    },
    setArticles(state, action) {
      state.articles = action.payload.articles
    },
    setMaxPage(state, action) {
      state.maxPage = action.payload
    },
    setPageNumber(state, action) {
      state.pageNumber = action.payload
    },
    setLastFetchedPage(state, action) {
      state.lastFetchedPage = action.payload
    },
    setAdvanceQuery(state, action) {
      state.advanceSearchQuery = action.payload
    },
    resetsetAdvanceQuery(state) {
      state.advanceSearchQuery = {}
    },
    setAuthors(state, action) {
      state.authors = action.payload
    },
    setBookmarks(state, action) {
      console.log('setBookmarks', action.payload)
      state.bookmarks = action.payload
    },
    /* setSelectedAuthors(state, action) {
      const indexOfAuthor = state.selectedAuthors.indexOf(action.payload)
      if(indexOfAuthor > -1) {
        const arrayOfAuthors = [...state.selectedAuthors]
        arrayOfAuthors.splice(indexOfAuthor,1)
        state.selectedAuthors = arrayOfAuthors
      } else {
        state.selectedAuthors.push(action.payload)
      }
    }, */
    setLoadingAuthors(state, action) {
      state.loadingAuthors = action.payload
    },
    setLoadingPublications(state, action) {
      state.loadingPublications = action.payload
    },
    setPublications(state, action) {
      state.publications = action.payload
    },
    setLoadingMenu(state, action) {
      state.loadingMenu = action.payload
    },
    setMenu(state, action) {
      state.menu = action.payload
    },
    setTotalArticles(state, action) {
      state.totalArticles = action.payload
    }
  },
});

export const searchActions = searchSlice.actions;

export default searchSlice;
